import { apiSlice } from '../../apiSlice'
import {
  DeprecProdUnit,
  FetchproductionUnitsParams,
  CreateProductionUnitParams,
  UpdateProductionUnitParams,
  DeleteProductionUnitParams,
} from './models'

export const productionUnitsEndpoints = apiSlice.injectEndpoints({
  endpoints: builder => ({
    fetchProductionUnits: builder.query<DeprecProdUnit[], FetchproductionUnitsParams>({
      query: ({ assetCompanyID, assetID }) => ({
        url: '/ProductionUnits/FetchProductionUnits',
        method: 'GET',
        params: { assetCompanyID, assetID },
      }),
      providesTags: ['productionUnits'],
    }),

    createProductionUnit: builder.mutation<void, CreateProductionUnitParams>({
      query: data => ({
        url: '/ProductionUnits/Create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['productionUnits'],
    }),

    updateProductionUnit: builder.mutation<void, UpdateProductionUnitParams>({
      query: data => ({
        url: '/ProductionUnits/Update',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['productionUnits'],
    }),

    deleteProductionUnit: builder.mutation<void, DeleteProductionUnitParams>({
      query: ({ assetCompanyID, assetID, fiscalYear, fiscalPeriod }) => ({
        url: '/ProductionUnits/Delete',
        method: 'DELETE',
        params: { assetCompanyID, assetID, fiscalYear, fiscalPeriod },
      }),
      invalidatesTags: ['productionUnits'],
    }),

    getFiscalPeriodInfo: builder.query<any, { assetCompanyID: number }>({
      query: ({ assetCompanyID }) => ({
        url: '/ProductionUnits/GetFiscalPeriodInfo',
        method: 'GET',
        params: { assetCompanyID },
      }),
      providesTags: ['productionUnits'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchProductionUnitsQuery,
  useCreateProductionUnitMutation,
  useUpdateProductionUnitMutation,
  useDeleteProductionUnitMutation,
  useGetFiscalPeriodInfoQuery,
} = productionUnitsEndpoints
